import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import "./FormBox.css";
function FormBox(props) {
    return (_jsx("div", { children: _jsx("input", { name: props.name, type: props.type, placeholder: props.placeholder, className: "formbox-style", onChange: function (v) { return props.onChange(v.target.value); } }, void 0) }, void 0));
}
export default FormBox;



//////////////////
// WEBPACK FOOTER
// ./src/components/FormBox.tsx
// module id = 26
// module chunks = 0